/** Product Catalog URL prefix (matches inventory web app, e.g. /product-catalog/items). */
export const PC_BASE = '/product-catalog';

export const pcPaths = {
  items: `${PC_BASE}/items`,
  itemsCreate: `${PC_BASE}/items/create`,
  itemEdit: `${PC_BASE}/items/edit`,
  menus: `${PC_BASE}/menus`,
  menusCreate: `${PC_BASE}/menus/create`,
  menuPriceEditor: (id: string) => `${PC_BASE}/menus/${id}/prices`,
  happyHourWizard: `${PC_BASE}/menus/happy-hour-wizard`,
  menuPerformance: `${PC_BASE}/menus/performance`,
  menuEdit: `${PC_BASE}/menus/edit`,
  categories: `${PC_BASE}/categories`,
  categoriesCreate: `${PC_BASE}/categories/create`,
  categoryEdit: `${PC_BASE}/categories/edit`,
  modifiers: `${PC_BASE}/modifiers`,
  modifiersCreate: `${PC_BASE}/modifiers/create`,
  modifierEdit: `${PC_BASE}/modifiers/edit`,
  variations: `${PC_BASE}/variations`,
  variationsCreate: `${PC_BASE}/variations/create`,
  variationSetEdit: `${PC_BASE}/variations/edit`,
  /** @deprecated Use variations */ optionSets: `${PC_BASE}/variations`,
  /** @deprecated Use variationsCreate */ optionSetsCreate: `${PC_BASE}/variations/create`,
  /** @deprecated Use variationSetEdit */ optionSetEdit: `${PC_BASE}/variations/edit`,
  kitchenStations: `${PC_BASE}/kitchen-stations`,
  kitchenStationsCreate: `${PC_BASE}/kitchen-stations/create`,
  kitchenStationEdit: `${PC_BASE}/kitchen-stations/edit`,
  sessions: `${PC_BASE}/sessions`,
  sessionsCreate: `${PC_BASE}/sessions/create`,
  /** Edit URL has no id segment — session id is kept in store state. */
  sessionEdit: `${PC_BASE}/sessions/edit`,
  combos: `${PC_BASE}/combos`,
  combosCreate: `${PC_BASE}/combos/create`,
  comboEdit: `${PC_BASE}/combos/edit`,
  comboReport: `${PC_BASE}/combos/report`,
  setMenus: `${PC_BASE}/set-menus`,
  setMenusCreate: `${PC_BASE}/set-menus/create`,
  setMenuEdit: `${PC_BASE}/set-menus/edit`,
  availability: `${PC_BASE}/availability`,
  syncHistory: `${PC_BASE}/sync-history`,
} as const;
